
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SecurityMergePriorityDialog extends SiteEntityDialog<SecurityMergePriorityRow, any> {
        protected getFormKey() { return SecurityMergePriorityForm.formKey; }
        protected getIdProperty() { return SecurityMergePriorityRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergePriorityRow.localTextPrefix; }
        protected getNameProperty() { return SecurityMergePriorityRow.nameProperty; }
        protected getService() { return SecurityMergePriorityService.baseUrl; }

        protected form = new SecurityMergePriorityForm(this.idPrefix);

        constructor() {
            super();

            this.form.Name.element.closest(".category").addClass("CheckFields");

            new Serenity.Toolbar(($('<div/>').addClass('col-md-12').addClass('selectionToolbar').insertBefore(this.form.DealParentCode.getGridField())), {
                buttons: [
                    {
                        title: 'Select All',
                        cssClass: 'select-all-button',
                        icon: 'fa-check-square-o text-green',
                        onClick: () => {
                            this.form.DealParentCode.getGridField().closest('.category').find('.field input[type=checkbox]')
                                .each((idx, el) => {
                                    $(el).prop('checked', 'checked');
                                });
                        }
                    },
                    {
                        title: 'Deselect All',
                        cssClass: 'deselect-all-button',
                        icon: 'fa-square-o text-red',
                        onClick: () => {
                            this.form.DealParentCode.getGridField().closest('.category').find('.field input[type=checkbox]')
                                .each((idx, el) => {
                                    $(el).prop('checked', null);
                                });
                        }

                    }
                ]
            });
        } 

        loadEntity(entity) {
            super.loadEntity(entity);

            if (this.isNew()) {
                this.form.DealParentCode.getGridField().closest('.category').find('.field input[type=checkbox]').each((idx, el) => {
                    var name = $(el).attr('name');
                    if (name && entity[name] == null) {
                        $(el).prop('checked', 'checked');
                    }
                });
            }
        }
    }
}